module.exports = __webpack_public_path__ + "static/media/BR2.8a5af158.webp";